export type Plan = "free" | "pro";

export interface AIModel {
  value: string;
  label: string;
  labelKey?: string;
  tier: Plan;
  hidden?: boolean;
}

export const MODELS: AIModel[] = [
  { value: "auto", label: "Auto", labelKey: "common.auto", tier: "free" },
  { value: "gpt-4.1-mini-2025-04-14", label: "GPT-4.1 Mini", tier: "free", hidden: true },
  { value: "gpt-5-mini-2025-08-07", label: "GPT-5 Mini", tier: "free" },
  { value: "gpt-5.2-chat-latest", label: "GPT-5.2", tier: "pro" },
  { value: "gemini-3.1-pro-preview", label: "Gemini 3.1 Pro", tier: "pro" },
  { value: "claude-sonnet-4-6", label: "Claude Sonnet 4.6", tier: "pro" },
  { value: "grok-4.1", label: "Grok 4.1", tier: "pro" },
];

export const FREE_MODEL_VALUES = new Set(
  MODELS.filter((m) => m.tier === "free").map((m) => m.value)
);

export const DEFAULT_MODEL = "gpt-4.1-mini-2025-04-14";

/** Resolve "auto" to a concrete model ID. */
export function resolveModel(selectedModel: string): string {
  if (selectedModel === "auto") {
    return DEFAULT_MODEL;
  }
  return selectedModel;
}
